import type { Template } from "@/types";

export const LA_03_H3_V0: Template[] = [
    {
        id: "la-03-h3v0-01",
        name: "LA 01 - H3V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h3_v0_01.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 63, y: 65, width: 549, height: 401, rotation: 0, imageRotation: 0 },
            { id: "2", x: 845, y: 65, width: 339, height: 197, rotation: 0, imageRotation: 0 },
            { id: "3", x: 845, y: 270, width: 339, height: 196, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h3v0-02",
        name: "LA 02 - H3V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h3_v0_02.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 168, y: 65, width: 339, height: 197, rotation: 0, imageRotation: 0 },
            { id: "2", x: 168, y: 270, width: 339, height: 196, rotation: 0, imageRotation: 0 },
            { id: "3", x: 740, y: 65, width: 549, height: 401, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h3v0-03",
        name: "LA 03 - H3V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h3_v0_03.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 51, y: 55, width: 575, height: 422, rotation: 0, imageRotation: 0 },
            { id: "2", x: 722, y: 158, width: 289, height: 214, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1019, y: 158, width: 288, height: 214, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h3v0-04",
        name: "LA 04 - H3V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h3_v0_04.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 676, height: 531, rotation: 0, imageRotation: 0 },
            { id: "2", x: 706, y: 153, width: 305, height: 227, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1019, y: 153, width: 304, height: 227, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h3v0-05",
        name: "LA 05 - H3V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h3_v0_05.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 42, y: 121, width: 418, height: 290, rotation: 0, imageRotation: 0 },
            { id: "2", x: 468, y: 121, width: 418, height: 290, rotation: 0, imageRotation: 0 },
            { id: "3", x: 894, y: 121, width: 417, height: 290, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h3v0-06",
        name: "LA 06 - H3V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h3_v0_06.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 29, y: 153, width: 304, height: 227, rotation: 0, imageRotation: 0 },
            { id: "2", x: 341, y: 153, width: 305, height: 227, rotation: 0, imageRotation: 0 },
            { id: "3", x: 676, y: 0, width: 676, height: 531, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h3v0-07",
        name: "LA 07 - H3V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h3_v0_07.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 99, y: 136, width: 380, height: 259, rotation: 0, imageRotation: 0 },
            { id: "2", x: 487, y: 136, width: 380, height: 259, rotation: 0, imageRotation: 0 },
            { id: "3", x: 875, y: 136, width: 379, height: 259, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h3v0-08",
        name: "LA 08 - H3V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h3_v0_08.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 104, width: 446, height: 324, rotation: 0, imageRotation: 0 },
            { id: "2", x: 454, y: 104, width: 445, height: 324, rotation: 0, imageRotation: 0 },
            { id: "3", x: 907, y: 104, width: 445, height: 324, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h3v0-09",
        name: "LA 09 - H3V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h3_v0_09.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 125, y: 39, width: 360, height: 223, rotation: 0, imageRotation: 0 },
            { id: "2", x: 125, y: 270, width: 360, height: 223, rotation: 0, imageRotation: 0 },
            { id: "3", x: 645, y: 39, width: 670, height: 451, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h3v0-10",
        name: "LA 10 - H3V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h3_v0_10.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 46, y: 166, width: 305, height: 198, rotation: 0, imageRotation: 0 },
            { id: "2", x: 359, y: 59, width: 635, height: 413, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1002, y: 166, width: 305, height: 198, rotation: 0, imageRotation: 0 }
        ],
    }
];